module.exports = __webpack_public_path__ + "img/WY.cc2ee188.png";